import {
  User,
  EnvelopeSimple,
  Phone,
  Buildings,
  Globe,
  Bell,
} from '@phosphor-icons/react'

import { useLang } from '../../context/LangContext'
import { useAuth } from '../../context/AuthContext'

export default function ProfilePage() {
  const { t, lang, setLang } = useLang()
  const { user } = useAuth()

  return (
    <div className="page page--wide profile-page">
      <div className="profile-hero">

        <div className="profile-hero__content">
          <h1>{t('myProfile')}</h1>
        </div>
      </div>

      <div className="profile-layout">
        <aside className="profile-sidebar-panel">
          <div className="profile-mini-card">
            <div className="profile-mini-card__icon">
              <User size={22} />
            </div>
            <div>
              <span>{t('profileSub')}</span>
            </div>
          </div>

          <div className="profile-info-list">
            <div>
              <EnvelopeSimple size={18} />
              <span>{user?.email}</span>
            </div>
            <div>
              <Phone size={18} />
              <span>{user?.phone}</span>
            </div>
            <div>
              <Buildings size={18} />
              <span>{user?.department}</span>
            </div>
          </div>
        </aside>

        <main className="profile-main-panel">
          <section className="profile-section-card">
            <div className="profile-section-card__header">
              <div>
                <h2>{t('personalInfo')}</h2>
                <p>Update your contact and account information.</p>
              </div>
            </div>

            <div className="profile-form-grid">
              <div className="form-group">
                <label className="form-label">{t('firstName')}</label>
                <input className="form-input" defaultValue="Ahmad" />
              </div>

              <div className="form-group">
                <label className="form-label">{t('lastName')}</label>
                <input className="form-input" defaultValue="Abdullah" />
              </div>

              <div className="form-group">
                <label className="form-label">{t('email')}</label>
                <input className="form-input" defaultValue={user?.email} />
              </div>

              <div className="form-group">
                <label className="form-label">{t('phone')} ({t('optional')})</label>
                <input className="form-input" defaultValue={user?.phone} />
              </div>

              <div className="form-group form-group--full">
                <label className="form-label">{t('department')}</label>
                <input className="form-input" defaultValue={user?.department} />
              </div>
            </div>

            <div className="form-actions">
              <button className="btn btn--ghost">{t('discard')}</button>
              <button className="btn btn--primary">{t('saveChanges')}</button>
            </div>
          </section>

          <section className="profile-section-card">
            <div className="profile-section-card__header">
              <div>
                <h2>{t('preferences')}</h2>
                <p>Manage language and notification preferences.</p>
              </div>
            </div>

            <div className="preference-grid">
              <label className="preference-card">
                <div className="preference-card__icon">
                  <Globe size={22} />
                </div>
                <div className="preference-card__body">
                  <strong>{t('language')}</strong>
                  <span>Choose your preferred portal language.</span>
                  <select
                    className="form-select"
                    value={lang}
                    onChange={(e) => setLang(e.target.value)}
                  >
                    <option value="en">English (EN)</option>
                    <option value="bm">Bahasa Malaysia (BM)</option>
                  </select>
                </div>
              </label>

              <label className="preference-card">
                <div className="preference-card__icon">
                  <Bell size={22} />
                </div>
                <div className="preference-card__body">
                  <strong>{t('emailNotif')}</strong>
                  <span>Control how often you receive ticket updates.</span>
                  <select className="form-select" defaultValue="all">
                    <option value="all">{t('allUpdates')}</option>
                    <option value="status">{t('statusOnly')}</option>
                    <option value="none">{t('none')}</option>
                  </select>
                </div>
              </label>
            </div>

            <div className="form-actions">
              <button className="btn btn--ghost">{t('discard')}</button>
              <button className="btn btn--primary">{t('saveChanges')}</button>
            </div>
          </section>
        </main>
      </div>
    </div>
  )
}
